
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    downloadData: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const isImage = computed(() => props.downloadData.isImage)

    const getSvg = computed(() => isImage.value ? 'image' : 'document-text')

    return {
      getSvg
    }
  }
})

